export const ESupportedNativeCode = {
  En: "en",
  Ko: "ko",
} as const;

export type ESupportedNativeCode =
  typeof ESupportedNativeCode[keyof typeof ESupportedNativeCode];
